<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12 mb-4">
        <div class="card card-plain border border-primary">
          <div class="card-header text-start bg-primary">
            <h6 class="text-white">검색필터</h6>
          </div>
          <div class="card-body bg-white" style="border-bottom-left-radius: 1rem;border-bottom-right-radius: 1rem;">
            <div class="row">
              <div class="col-5 col-xl-5 mb-4"><input type="text" class="form-control" v-model="searchName" placeholder="코인명을 입력해주세요."  @keyup="SearchList"/></div>
              <div class="col-5 col-xl-5 mb-4">
                <select class="form-select" v-model="searchStatus" @change = "SearchList">
                  <option value="" style="display:none">코인 상태를 선택해주세요.</option>
                  <option :value="item.code"  v-for="(item,index) in statusList" :key="index">{{item.text}}</option>
                </select>
              </div>

              <div class="col-2 col-xl-2 mb-4"><button class="btn mb-0 btn-primary" data-bs-toggle="modal" data-bs-target="#add_coin">코인 추가</button></div>

            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card card-plain border border-info">
          <div class="card-header text-start bg-info">
            <h6 class="text-white">코인정보</h6>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                <tr>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">블록체인</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">코인명</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">컨트랙트 주소</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">심볼</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">상태</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">등록일</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">수정일</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="(item,index) in list" :key="index">
                  <td>
                    <div class="d-flex px-2 py-1">
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">{{item.chain_name}}</h6>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div class="d-flex px-2 py-1">
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">{{item.name}}</h6>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div class="d-flex px-2 py-1">
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">{{item.contract}}</h6>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div class="d-flex px-2 py-1">
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">{{item.symbol}}</h6>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div class="d-flex px-2 py-1">
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">{{item.is_active === 1 ? '활성' : '비활성'}}</h6>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div class="d-flex px-2 py-1">
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">{{item.created}}</h6>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div class="d-flex px-2 py-1">
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">{{item.updated}}</h6>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div class="d-flex px-2 py-1">
                      <i class="fa fa-edit px-2" @click="this.CheckDetailEdit(item)" data-bs-toggle="modal" data-bs-target="#edit_coin"></i>
                      <i class="fa fa-trash px-2" @click="this.CheckDetailDelete(item)"   data-bs-toggle="modal" data-bs-target="#delete_coin"></i>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>

            </div>
            <hr class="horizontal dark" />
            <ul class="pagination pagination-primary pagination-sm d-flex justify-content-center">
              <li class="page-item" v-if="max_page > 5">
                <a class="page-link" href="javascript:void(0);" @click="PrevPage">
                  <i class="fa fa-angle-left"></i>
                </a>
              </li>
              <li class="page-item " :class="this.CheckPage(n)" v-for="n in max_page" :key="'Page_'+n">
                <a class="page-link" href="javascript:void(0);"  @click="this.ClickPaging(n)">
                  {{n}}
                </a>
              </li>
              <li class="page-item"  v-if="max_page > 5" >
                <a class="page-link" href="javascript:void(0);" @click="NextPage">
                  <i class="fa fa-angle-right"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="add_coin">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">코인 추가</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>

          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">블록체인</label>
            <select class="form-select" v-model="coin.seq_chain" required>
              <option :value="item.seq" v-for="(item, index) in chainList" :key="index" >{{item.name}}</option>
            </select>

            <label for="example-text-input" class="form-control-label">코인명</label>
            <input type="text" class="form-control" v-model="coin.name" placeholder="코인명을 입력해주세요." />

            <label for="example-text-input" class="form-control-label">컨트랙트 주소</label>
            <input type="text" class="form-control" v-model="coin.contract" placeholder="컨트랙트 주소를 입력해주세요." />

            <label for="example-text-input" class="form-control-label">심볼</label>
            <input type="text" class="form-control" v-model="coin.symbol" placeholder="심볼을 입력해주세요." />

            <label for="example-text-input" class="form-control-label">상태</label>
            <select class="form-select" v-model="coin.status">
              <option value="1">활성</option>
              <option value="0">비활성</option>
            </select>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="AddCoin">추가</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="edit_coin">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">코인 수정</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>

          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">블록체인</label>
            <select class="form-select" v-model="coin.seq_chain" required>
              <option :value="item.seq" v-for="(item, index) in chainList" :key="index" >{{item.name}}</option>
            </select>

            <label for="example-text-input" class="form-control-label">코인명</label>
            <input type="text" class="form-control" v-model="coin.name" placeholder="코인명을 입력해주세요." />

            <label for="example-text-input" class="form-control-label">컨트랙트 주소</label>
            <input type="text" class="form-control" v-model="coin.contract" placeholder="컨트랙트 주소를 입력해주세요." />

            <label for="example-text-input" class="form-control-label">심볼</label>
            <input type="text" class="form-control" v-model="coin.symbol" placeholder="심볼을 입력해주세요." />

            <label for="example-text-input" class="form-control-label">상태</label>
            <select class="form-select" v-model="coin.status">
              <option value="1">활성</option>
              <option value="0">비활성</option>
            </select>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="EditCoin">수정</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="delete_coin">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">코인 삭제</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>

          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">코인명</label>
            <input type="text" class="form-control" v-model="coin.name" disabled />

            <label for="example-text-input" class="form-control-label">컨트랙트 주소</label>
            <input type="text" class="form-control" v-model="coin.contract" disabled />

            <label for="example-text-input" class="form-control-label">심볼</label>
            <input type="text" class="form-control" v-model="coin.symbol" disabled />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="DeleteCoin">삭제</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const exactMath = require('exact-math');
import {Modal} from "bootstrap";
import {mapMutations} from "vuex";
import CryptoJS from "crypto-js";

export default {
  name: "tables",

  data() {
    return {
      limit: 10,
      page: 1,
      max_page: 0,
      show : 3,

      mobile: this.$store.state.mobile,
      show_mobile: this.$store.state.show_mobile,

      searchName: '',
      searchStatus: '',

      statusList: [
        {code: '1', text: '활성화'},
        {code: '0', text: '비활성화'},
      ],

      list: [],
      chainList: [],
      AddModal: '',
      EditModal: '',
      DeleteModal: '',

      coin: {},
    }
  },

  mounted(){
    this.AddModal = new Modal(document.getElementById('add_coin'));
    this.EditModal = new Modal(document.getElementById('edit_coin'));
    this.DeleteModal = new Modal(document.getElementById('delete_coin'));

    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.isAbsolute = false;
    this.$store.state.showConfig = false;

    if (this.mobile === true) {
      if (this.show_mobile === true) {
        this.navbarMinimize();
      }
    }

    this.GetCoinList();
    this.GetChainList()
  },

  methods: {
    ...mapMutations(["navbarMinimize"]),

    ClickPaging(i){
      this.page = i;
      this.GetCoinList();
    },

    CheckPage(i){
      const show = this.show;
      const page = this.page;
      let add_class ='';

      if ((i+2) === show) {
        if (page === i) {
          add_class = " active ";
        }

      } else if((i+1) === show) {
        if (page === i) {
          add_class = " active ";
        }

      } else if((i) === show) {
        if (page === i) {
          add_class = " active ";
        }

      } else if((i-1) === show) {
        if (page === i) {
          add_class = " active ";
        }

      } else if((i-2) === show) {
        if (page === i) {
          add_class = " active ";
        }
      } else {
        add_class += 'd-none';
      }

      return add_class;

    },

    PrevPage(){
      const show = this.show;
      const show_prev = exactMath.sub(show,1);

      if (show_prev >= 3) {
        this.show = show_prev;
      } else {
        this.show = show;
      }
    },

    NextPage(){
      const show = this.show;
      const show_next = exactMath.add(show,1);
      const max = exactMath.sub(this.max_page,2);

      if (show_next <= max) {
        this.show = show_next;
      } else {
        this.show = max;
      }
    },

    SearchList(){
      this.page = 1;
      this.show = 3;
      this.GetCoinList();
    },

    GetChainList() {
      const req = CryptoJS.AES.encrypt(JSON.stringify({}),process.env.VUE_APP_SECRET_TOKEN).toString();

      this.axios.post('/admin/coin/GetChainList', {req}).then(
          res => {
            if (res.status !== 200) {
              return
            }

            if (res.data.code === '9999') {
              this.$store.dispatch('SETLOGOUT').then(
                  ()=>{
                    window.location.href="/login";
                  }
              )

              return
            }

            const e_body = res.data.body;
            const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
            const d_res = bytes.toString(CryptoJS.enc.Utf8);
            const body = JSON.parse(d_res)
            this.chainList = body.list;
          }
      )
    },

    GetCoinList() {
      const page = this.page;
      const limit = this.limit;

      const searchName = this.searchName;
      const searchStatus = this.searchStatus;

      const rbody = {page, searchName, limit, searchStatus};
      const req = CryptoJS.AES.encrypt(JSON.stringify(rbody),process.env.VUE_APP_SECRET_TOKEN).toString();

      this.axios.post('/admin/coin/GetList', {req}).then(
          res => {
            if (res.status !== 200) {
              return
            }

            if (res.data.code === '9999') {
              this.$store.dispatch('SETLOGOUT').then(
                  ()=>{
                    window.location.href="/login";
                  }
              )

              return
            }

            this.max_page = res.data.count;
            const e_body = res.data.body;
            const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
            const d_res = bytes.toString(CryptoJS.enc.Utf8);
            const body = JSON.parse(d_res)
            this.list = body.list;

            this.max_page = body.count;
          }
      )
    },

    CheckDetailEdit(item) {
      this.coin = {
        seq: item.seq,
        seq_chain: item.seq_chain,
        name: item.name,
        contract: item.contract,
        symbol: item.symbol,
        status: item.is_active,
      }
    },

    CheckDetailDelete(item) {
      this.coin = {
        seq: item.seq,
        name: item.name,
        contract: item.contract,
        symbol: item.symbol,
      }
    },

    AddCoin() {
      const seqChain = this.coin.seq_chain
      if (seqChain === undefined || seqChain === '') {
        this.$alert.alert("블록체인을 선택해주세요.").then(
            ()=>{
              this.AddModal.show();
            }
        );
        return false;
      }

      const name = this.coin.name
      if (name === undefined || name === '') {
        this.$alert.alert("코인명을 입력해주세요.").then(
            ()=>{
              this.AddModal.show();
            }
        );
        return false;
      }

      const contract = this.coin.contract
      if (contract === undefined || contract === '') {
        this.$alert.alert("컨트랙트 주소를 입력해주세요.").then(
            ()=>{
              this.AddModal.show();
            }
        );
        return false;
      }

      const symbol = this.coin.symbol
      if (symbol === undefined || symbol === '') {
        this.$alert.alert("심볼을 입력해주세요.").then(
            ()=>{
              this.AddModal.show();
            }
        );
        return false;
      }

      const status = this.coin.status
      if (status === undefined || status === '') {
        this.$alert.alert("상태를 입력해주세요.").then(
            ()=>{
              this.AddModal.show();
            }
        );
        return false;
      }

      const body = {
        seqChain,
        name,
        contract,
        symbol,
        status,
      }
      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();

      this.axios.post('/admin/coin/AddCoin', {req}).then(
          res => {
            if (res.status !== 200) {
              return
            }

            if (res.data.code === 9999) {
              this.$store.dispatch('SETLOGOUT').then(
                  ()=>{
                    window.location.href="/login";
                  }
              )

              return
            } else if (res.data.code === 9900) {
              this.$alert.alert("동일한 코인이 있습니다.");

              return
            }

            this.$alert.alert("코인을 추가하였습니다.");
            this.SearchList();
          }
      )
    },

    EditCoin() {
      const seqChain = this.coin.seq_chain
      if (seqChain === undefined || seqChain === '') {
        this.$alert.alert("블록체인을 선택해주세요.").then(
            ()=>{
              this.AddModal.show();
            }
        );
        return false;
      }

      const name = this.coin.name
      if (name === undefined || name === '') {
        this.$alert.alert("코인명을 입력해주세요.").then(
            ()=>{
              this.AddModal.show();
            }
        );
        return false;
      }

      const contract = this.coin.contract
      if (contract === undefined || contract === '') {
        this.$alert.alert("컨트랙트 주소를 입력해주세요.").then(
            ()=>{
              this.AddModal.show();
            }
        );
        return false;
      }

      const symbol = this.coin.symbol
      if (symbol === undefined || symbol === '') {
        this.$alert.alert("심볼을 입력해주세요.").then(
            ()=>{
              this.AddModal.show();
            }
        );
        return false;
      }

      const status = this.coin.status
      if (status === undefined || status === '') {
        this.$alert.alert("상태를 입력해주세요.").then(
            ()=>{
              this.AddModal.show();
            }
        );
        return false;
      }

      const seq = this.coin.seq
      const body = {
        seq,
        seqChain,
        name,
        contract,
        symbol,
        status,
      }
      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();

      this.axios.post('/admin/coin/EditCoin', {req}).then(
          res => {
            if (res.status !== 200) {
              return
            }

            if (res.data.code === 9999) {
              this.$store.dispatch('SETLOGOUT').then(
                  ()=>{
                    window.location.href="/login";
                  }
              )

              return
            } else if (res.data.code === 9900) {
              this.$alert.alert("동일한 코인이 있습니다.");

              return
            }

            this.$alert.alert("코인이 수정되었습니다.");
            this.SearchList();
          }
      )
    },

    DeleteCoin() {
      const seq = this.coin.seq
      const body = {
        seq
      }

      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();

      this.axios.post('/admin/coin/DeleteCoin', {req}).then(
          res => {
            if (res.status !== 200) {
              return
            }

            if (res.data.code === 9999) {
              this.$store.dispatch('SETLOGOUT').then(
                  ()=>{
                    window.location.href="/login";
                  }
              )

              return
            }

            this.$alert.alert("코인을 삭제했습니다.");
            this.SearchList();
          }
      )
    },
  }
}
</script>
